import React from 'react'
import '../src/App.css'
import {BrowserRouter as Router,Routes,Route} from 'react-router-dom'
import Header from './component/header/Header'
import Home from './Pages/home/Home'
import Movielist from './component/movieList/Movielist'
import Movie from '../src/Pages/moviedetail/Movie.js'
const App = () => {
  return (
    <div className="App">
<Router>
  <Header/>
<Routes>
  <Route index element={<Home/>}></Route>
  <Route path='movie/:id' element={<Movie/>}></Route>
  <Route path='movies/:type' element={<Movielist/>}></Route>
  <Route path='/' element={<h1>Error Page</h1>}></Route>

</Routes>
</Router>
</div>
  )
}

export default App